/**
 * Globaler Hintergrund-Layer — liegt fixed hinter der gesamten Seite.
 * Gibt dem dunklen Grund Struktur: Punktraster, feines Linien-Grid,
 * langsam driftende Glow-Orbs im Branding-Lila und ein diagonaler Licht-Beam.
 * Rein dekorativ (aria-hidden, pointer-events-none), CSS-only Animationen.
 */
const BackgroundFX = () => (
  <div aria-hidden="true" className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
    {/* Basis-Verlauf: oben minimal heller als unten (Tiefe) */}
    <div
      className="absolute inset-0"
      style={{ background: "radial-gradient(120% 90% at 50% 0%, hsl(222 47% 13.5%), hsl(var(--background)) 70%)" }}
    />

    {/* Feines Punktraster */}
    <div
      className="absolute inset-0"
      style={{
        backgroundImage: "radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px)",
        backgroundSize: "28px 28px",
      }}
    />

    {/* Grobes Linien-Grid (sehr dezent) */}
    <div
      className="absolute inset-0"
      style={{
        backgroundImage:
          "linear-gradient(rgba(255,255,255,0.045) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.045) 1px, transparent 1px)",
        backgroundSize: "160px 160px",
      }}
    />

    {/* Driftende Glow-Orbs */}
    <div
      className="absolute rounded-full animate-drift-a"
      style={{
        width: "55vw", height: "55vw", top: "-18%", left: "-12%",
        background: "hsl(var(--accent) / 0.17)", filter: "blur(140px)",
      }}
    />
    <div
      className="absolute rounded-full animate-drift-b"
      style={{
        width: "45vw", height: "45vw", top: "38%", right: "-14%",
        background: "hsl(280 70% 45% / 0.14)", filter: "blur(140px)",
      }}
    />
    <div
      className="absolute rounded-full animate-drift-c"
      style={{
        width: "40vw", height: "40vw", bottom: "-12%", left: "18%",
        background: "hsl(220 80% 50% / 0.11)", filter: "blur(130px)",
      }}
    />

    {/* Diagonaler Licht-Beam (wie Streiflicht am Set) */}
    <div
      className="absolute inset-0"
      style={{ background: "linear-gradient(115deg, transparent 42%, hsl(var(--accent) / 0.06) 50%, transparent 58%)" }}
    />
  </div>
);

export default BackgroundFX;
